import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yhc5n72agd: FaireBrandEntity = {
  token: "b_yhc5n72agd",
  type: "brand",
  name: "KEEP>GOING First Aid",
  avatarUrl:
    "https://cdn.faire.com/fastly/3c8e6c886fa32fd88f24d1f7072e954f09e203b1ed32cc1414c3805c94cc09d3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/60a86ae2cf83554a0f65393dce2aba92cb0028fd8f8d26da44c5f9a9b12fed35.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3c8e6c886fa32fd88f24d1f7072e954f09e203b1ed32cc1414c3805c94cc09d3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/60a86ae2cf83554a0f65393dce2aba92cb0028fd8f8d26da44c5f9a9b12fed35.jpeg",
  location: "WINTER PARK, FL, USA",
  minimumOrderDollars: 149,
  rating: 5,
  reviewCount: 29,
  isTopShop: true,
  isInsider: true,
  description:
    "First Aid Kits re-inveted for families! \n\nWe are a family business based out of Orlando, Florida. \nBut back in 2018, as parents of four young kids, can you believe my family and I traveled for 19 months to 23 different countries?\nIt was a whirlwind of an adventure, but our daily lifeline was our First Aid Kit! With kids around, anything can happen, and even the most minor injury can ruin a fun family outing.\n \nWith our First Aid Kit in hand, we had insurance to keep the kids smiling by removing splinters and ticks on the spot, preventing infections, or applying anti-itch cream whenever needed.\n\nBut the kits on the market were clunky and heavy and included cheap items that weren't even practical for families. Not to mention that the cases gave more of an army vibe than a cool mom vibe.\n\nWe decided that busy moms deserved better! That's when the idea for an organized, practical, lightweight kit that included high-quality, useful items came to us. \nAfter extensive product analysis, several design sessions, experimentation, and hours of tweaking, KEEP>GOING First Aid was born!\n\nWe proudly present one-of-a-kind First Aid Kits tailored especially towards families you won't find anywhere else! \n\nWith  Love\nThe Pepper Family \n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:44.278Z",
    importedBy: "entity-db-cli",
  },
};
